import type { BoardTemplateContent, BoardTheme } from '@praesto/shared'

/**
 * Was im Anlege-Fenster gewählt wurde, bis das Board offen ist.
 *
 * Es kann nicht beim Anlegen mitgeschickt werden: Untergrund, Schriften und
 * Frames liegen im Yjs-Dokument, nicht in Postgres — dort gehören sie hin, weil
 * zwei Leute sie gleichzeitig ändern können. Geschrieben wird also erst, wenn
 * die Board-Ansicht das Dokument hat. Bis dahin liegt der Entwurf hier.
 *
 * Ein Modulwert reicht, weil dazwischen kein Seitenwechsel im Browser liegt —
 * der Router tauscht nur die Ansicht aus. Wird das Board doch nicht geöffnet,
 * verfällt der Eintrag mit dem nächsten Neuladen; er wird bewusst nicht
 * persistiert, sonst überschriebe er später einmal ein bereits gestaltetes
 * Board.
 */
export interface InitialDesign {
  background: string
  theme: BoardTheme
  /** Das gewählte Gerüst; `null`, wenn das Board leer beginnen soll. */
  template: BoardTemplateContent | null
}

const pending = new Map<string, InitialDesign>()

export const rememberInitialDesign = (boardId: string, design: InitialDesign): void => {
  pending.set(boardId, design)
}

/** Liefert den Entwurf genau einmal und vergisst ihn dabei. */
export function takeInitialDesign(boardId: string): InitialDesign | null {
  const design = pending.get(boardId)
  if (!design) return null
  pending.delete(boardId)
  return design
}
